import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {EditPermissions} from '../../../../../../../shared/models';
import {required} from '../../../../../../../shared/utils';
import {getEditTypes} from '../../../delegatorUtils';
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';

export type ContactType = 'lookup' | 'insert';

export interface ContactBookData {
    name: string;
    description: string;
    contactType: ContactType;
    msisdn: string;
    useReturnFlow: boolean;
    yes: string;
    no: string;
}

export class ContactBook {
    action: any = {};

    constructor(formData: ContactBookData) {
        this.action = {actionType: 'contactBook'};
        this.setNodeData(formData);
    }

    static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): UntypedFormGroup {
        const {editFlows} = getEditTypes(editPermissions);
        const formData = this.getFromData(stepData);
        return this.buildForm(formData, editFlows);
    }

    private static getFromData(stepData: { [index: string]: any }): ContactBookData {
        const action = stepData?.action ?? {};
        const actionParams = action?.actionParams ?? {};
        const result = action?.result ?? {};

        return {
            name: action.name || '',
            description: action.description || '',
            contactType: actionParams.contactType || 'lookup',
            msisdn: actionParams.msisdn || '',
            useReturnFlow: actionParams.useReturnFlow || false,
            yes: result.yes || newStepValue,
            no: result.no || newStepValue,
        };
    }

    private static buildForm(formData: ContactBookData, editFlows: boolean): UntypedFormGroup {
        return new UntypedFormGroup({
            name: new UntypedFormControl({value: formData.name, disabled: !editFlows}, required('Name')),
            description: new UntypedFormControl({
                value: formData.description,
                disabled: !editFlows
            }, required('Description')),
            contactType: new UntypedFormControl({
                value: formData.contactType,
                disabled: !editFlows
            }, required('Contact Type')),
            msisdn: new UntypedFormControl({value: formData.msisdn, disabled: !editFlows}),
            useReturnFlow: new UntypedFormControl({value: formData.useReturnFlow, disabled: !editFlows}),
            yes: new UntypedFormControl(formData.yes),
            no: new UntypedFormControl(formData.no),
        });
    }

    get nodeData(): {} {
        return {
            action: this.action,
            type: 'action',
            metadata: {nodeVersion: '1.0.0'},
        };
    }

    setNodeData(formData: ContactBookData) {
        const {name, description, contactType, msisdn, useReturnFlow, yes, no} = formData;

        const actionParams: any = {contactType, useReturnFlow};

        if (contactType === 'insert') {
            actionParams.msisdn = msisdn;
        }

        const result = useReturnFlow && contactType === 'insert'
            ? {no}
            : {yes, no};

        this.action = {
            ...this.action,
            name,
            description,
            actionParams,
            result,
        };
    }
}
